// prop-type is a library for typechecking of props
import PropTypes from 'prop-types'
import { useState } from 'react'
// Soft UI Dashboard PRO React components
import { PatternFormat } from 'react-number-format'
import FormField from 'components/FormField'
import { useFieldState } from 'hooks/useFieldState'
function PhoneNumberField({
  label,
  value,
  onChange,
  required,
  defaultErrorState,
  onBlur,
  forceError,
  ...rest
}) {
  const [rawValue, setRawValue] = useState(value)
  const validatePhoneNumber = (value) => {
    console.log('validate phone from phone file')
    return (
      `${value}`.match(/^\+1\d{10}$/) ||
      `${value}`.match(/^\+1 \(\d{3}\) \d{3}-\d{4}$/)
    )
  }
  const { isError, isSuccess, handleOnblur } = useFieldState({
    required,
    defaultErrorState,
    validatorFunction: validatePhoneNumber,
    forceError,
  })
  const handleOnblurWithValidation = (value) => {
    const isValid = validatePhoneNumber(value)
    handleOnblur?.(value)
    if (isValid) {
      onBlur?.(rawValue)
    }
  }
  return (
    <PatternFormat
      format="+1 (###) ###-####"
      allowEmptyFormatting
      mask="_"
      label={label}
      customInput={FormField}
      value={value}
      inputProps={{ inputMode: 'numeric' }}
      error={isError}
      success={isSuccess}
      onBlur={handleOnblurWithValidation}
      onValueChange={(values, _sourceInfo) => {
        setRawValue(values.value)
        onChange(values.value)
      }}
      required={required}
      {...rest}
    />
  )
}

// typechecking props for PhoneNumberField
PhoneNumberField.propTypes = {
  label: PropTypes.string.isRequired,
}

export default PhoneNumberField
